var map = {
	"./add.svg": 3211,
	"./assign-outpoints.svg": 7523,
	"./badges/badge-new.svg": 78939,
	"./bin.svg": 6149,
	"./cancel.svg": 77240,
	"./checkbox-check.svg": 69802,
	"./chevron-down.svg": 13636,
	"./chevron-right.svg": 68870,
	"./clone-regular.svg": 87326,
	"./cloud_upload_icon.svg": 36645,
	"./dashboard-empty.png": 73397,
	"./dashboard-new.png": 68412,
	"./error.svg": 27084,
	"./expand-arrows-light.svg": 72826,
	"./export.svg": 86024,
	"./favicon.svg": 90870,
	"./home-lg-alt-light.svg": 84494,
	"./icon-adobe.svg": 41207,
	"./icon-circle-down.svg": 73243,
	"./icon-cog-light.svg": 25204,
	"./icon-game-controller.svg": 55429,
	"./icon-google.svg": 40047,
	"./icon-heart.svg": 71206,
	"./icon-more.svg": 87469,
	"./icon-sort-down.svg": 22691,
	"./icon-sort-up.svg": 34108,
	"./icon-star.svg": 61034,
	"./icon-tick.svg": 35849,
	"./icons/icon-arrows-up-down-left-right-solid.svg": 47849,
	"./icons/icon-play.svg": 56411,
	"./image-line.svg": 37660,
	"./image-screens.svg": 5705,
	"./incoming-links.svg": 54738,
	"./info.svg": 50862,
	"./invalid-input.svg": 20904,
	"./link-regular.svg": 37661,
	"./linked-story-islands.svg": 33424,
	"./list.svg": 76962,
	"./loader.svg": 99183,
	"./logo-stornaway--icon.svg": 42243,
	"./logo-stornaway.svg": 72710,
	"./media.svg": 54422,
	"./og-default.png": 40263,
	"./outpoint-styling.svg": 38577,
	"./placeholder-project.svg": 68533,
	"./player-exit-fullscreen.svg": 18368,
	"./player-fullscreen.svg": 91341,
	"./player-redo.svg": 60174,
	"./player-undo.svg": 22072,
	"./plus-light.svg": 57857,
	"./prompt.svg": 13752,
	"./question-circle-light.svg": 47960,
	"./replace.svg": 24194,
	"./script.svg": 5531,
	"./search-minus-light.svg": 44062,
	"./search-plus-light.svg": 48068,
	"./send.svg": 89320,
	"./stars-thin.svg": 63203,
	"./step-backward.svg": 12062,
	"./step-forward.svg": 76300,
	"./stornaway-logo-icon.svg": 25630,
	"./stornaway-logo-white.svg": 68268,
	"./stornaway-logo.png": 34843,
	"./stornaway-logo.svg": 22972,
	"./story-island.svg": 93905,
	"./tab-background-filled.svg": 1877,
	"./tab-background-left.svg": 2066,
	"./tab-background-middle.svg": 20174,
	"./tab-background-right.svg": 69001,
	"./user-circle-light.svg": 25871,
	"./variant-end.svg": 14749,
	"./variant-restart.svg": 15775,
	"./variant-start.svg": 5878,
	"./variant.svg": 83001,
	"./visibility-off.svg": 42542,
	"./visibility.svg": 16686,
	"./w-and-rp.svg": 60412,
	"./watchandreplay.svg": 94927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7546;